import useChatStore, {
  COLUMNS,
  GRID,
  ROWS,
  TABS,
} from '@/Components/Chat/store';
import {
  GridIcon,
  RowsIcon,
  TabsIcon,
  TreeIcon,
} from '@/Theme/icons/sideBySideIcons';
import useThemeStore from '@/Theme/store';
import { cn } from '@/utils/styles';
import { Tooltip } from '@mui/material';
import { memo } from 'react';

const getRenderIcon = (type, className = '', onClick) => {
  switch (type) {
    case TABS:
      return <TabsIcon className={className} onClick={onClick} />;
    case COLUMNS:
      return <TreeIcon className={className} onClick={onClick} />;
    case ROWS:
      return <RowsIcon className={className} onClick={onClick} />;
    case GRID:
      return <GridIcon className={className} onClick={onClick} />;
    default:
      break;
  }
};

const getTooltipTitle = (type) => {
  switch (type) {
    case TABS:
      return 'Tab View';
    case COLUMNS:
      return 'Tree View';
    case ROWS:
      return 'Row View';
    case GRID:
      return 'Grid View';
    default:
      return '';
  }
};

const VerticalMenu = ({ className }) => {
  const { theme } = useThemeStore();
  const isDark = theme === 'dark';
  const menuItems = [
    {
      id: TABS,
    },
    {
      id: COLUMNS,
    },
    {
      id: ROWS,
    },
    {
      id: GRID,
    },
  ];

  const { renderType, setRenderType } = useChatStore((state) => ({
    renderType: state.renderType,
    setRenderType: state.setRenderType,
  }));
  const isActive = (id) => {
    return renderType === id;
  };

  return (
    <div
      className={cn(
        'hidden md:flex flex-col items-center gap-1 p-1 bg-white dark:bg-night-black rounded-[16px] shadow-lg',
        isDark ? 'text-white' : 'text-raisin-black',
        className
      )}
    >
      {menuItems.map((item) => (
        <Tooltip
          key={item.id}
          title={getTooltipTitle(item.id)}
          arrow
          placement="left"
        >
          <button
            className={cn(
              'p-1 rounded-lg transition-all duration-200 ease-in-out cursor-pointer hover:text-nue-blue hover:dark:text-[#5256A6]',
              {
                'text-nue-blue dark:text-[#5256A6] bg-nue-blue/15 dark:bg-[#51526C]/15 rounded-xl':
                  isActive(item.id),
                'text-white': isDark && !isActive(item.id),
                'text-raisin-black': !isDark && !isActive(item.id),
              }
            )}
          >
            {getRenderIcon(item.id, 'select-none size-4', () =>
              setRenderType(item.id)
            )}
          </button>
        </Tooltip>
      ))}
    </div>
  );
};

export default memo(VerticalMenu);
